import React from "react";
import { Card } from "react-bootstrap";
import connectionImage from "src/assets/images/connection.svg";

type AllProps = {
  pin: string;
}

// Description: WebSocket Component showing that the connection is active and requesting a pin
function ActiveConnectionComponent(props: AllProps) {
  const { pin } = props;
  
  return <Card className="pv-card">
    <Card.Img variant="top" src={connectionImage} />
    <Card.Body>
      <h2><i className="connected"></i> Connection Active </h2>
      <p className="pin">{pin}</p>
    </Card.Body>
  </Card>;
}

export default React.memo(ActiveConnectionComponent);